module.exports = __webpack_public_path__ + "img/nu.1f58e670.jpg";